import React from "react";
import { useDispatch } from "react-redux";
import Container from "react-bootstrap/Container";
import { Row, Image } from "react-bootstrap";
import "./SharedSection.scss";
import { useTranslation } from "react-i18next";
import shareImage from 'assets/images/share.png';
import { SHOW_SHARE_BUTTON } from "utils/Config";

export const BlockedSharedSection = ({ title, message }) => {
  if (!SHOW_SHARE_BUTTON) {
    return null
  }
  return (
    <Row className="share_block container">
      <SharedSection title={title} message={message} />
    </Row>
  )
}

const SharedSection = ({
  title,
  message,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const shareAction = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: message,
        });
      } catch (error) {
      }
    } else {
      navigator.clipboard.writeText(message);
      dispatch({
        type: "navBars/updateState",
        payload: {
          toastShowing: {
            value: true,
            content: t("copySuccessfully"),
            showTickIcon: true,
          },
        },
      });
    }
  }

  if (!SHOW_SHARE_BUTTON) {
    return null
  }

  return (
    <Container className="shared_container">
      <Row className="shared">
        <button
          className="share-button"
          onClick={shareAction}
        >
          <Image
            src={shareImage}
            className="share-image"
          />
          <label className="share-label button-large">
            {navigator.share ? t("share") : t("copy_to_share")}
          </label>
        </button>
      </Row>
    </Container>
  );
}

export default SharedSection;
